import { useStyles } from "./styles";

export const TractableLogo = () => {
  const { classes } = useStyles();
  return <img src="/assets/svg/tractable-logo.svg" alt="Tractable logo" className={classes.logo} />;
};
